import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, NavItem, NavDropdown, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import isEqual from 'react-fast-compare';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import { Badge } from 'ecs-react-components/dist/index.es';

import history from '../../history';
import { links } from '../../shared/links';
import { messages } from './Menu.i18n';
import { mapCapabilities } from '../../pages/HomePage/capability-mapper';
import { getUnreadCount } from '../../redux/modules/secure-message/secure-message-middleware';
import { logout } from '../../redux/modules/auth/auth-middleware';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import { findCcdaExternalSystems } from '../../redux/modules/health-summary/external-systems-mapper';
import { mapResourcesCapabilities } from './resources-mapper';
import NavSeparator from './NavSeparator';
import NavItemSeparator from './NavItemSeparator';
import LanguageSelectionDropdown from '../LanguageSelectionDropdown/LanguageSelectionDropdown';
import { SecureMessageNavLink } from '../../components/SecureMessage/SecureMessageNavLink';


class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerMenuOpen: false,
    };
    this.toggleHamburgerMenu = this.toggleHamburgerMenu.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props.capabilities, nextProps.capabilities) &&
      isEqual(this.props.stateCounter, nextProps.stateCounter) &&
      isEqual(this.props.externalSystems, nextProps.externalSystems) &&
      isEqual(this.props.isDedicatedWorkflow, nextProps.isDedicatedWorkflow) &&
      isEqual(this.props.patient, nextProps.patient) &&
      isEqual(this.props.user, nextProps.user) &&
      isEqual(this.state, nextState));
  }

  logout = (e) => {
    e.preventDefault();
    this.props.dispatch(MsgBarActions.dismissMessage());
    this.props.dispatch(logout());
    return false;
  };

  toggleHamburgerMenu(shouldDisplayMessage) {
    const { dispatch, patient, isAuthenticated, isDedicatedWorkflow } = this.props;
    if (isAuthenticated && !isDedicatedWorkflow && patient && patient.patientId) {
      // ***** HACK ALERT!!! ***** Stupid workaround because there is no push mechanism
      dispatch(getUnreadCount(patient.patientId));
    }
    this.setState({ hamburgerMenuOpen: !this.state.hamburgerMenuOpen });
    if (!shouldDisplayMessage) {
      dispatch(MsgBarActions.dismissMessage());
    }
  }

  displayMuCcdaNotConfiguredMessage = (handleToggleHamburgerMenu) => () => {
    this.props.dispatch(MsgBarActions.showErrorMessage('ccdaNotConfiguredError'));
    if (handleToggleHamburgerMenu) {
      handleToggleHamburgerMenu(true);
    }
  }

  buildLogo(navigation) {
    const { formatMessage } = this.props.intl;
    if (navigation == null) {
      return (<div className="navbar-brand navbar-logo">
      <div>
      <Image src={this.props.logo} className="img-responsive"
        alt={ formatMessage(messages.headerLogo) + this.props.facilityName }
      />
      </div>
              </div>);
    }
    return (<div className="navbar-brand navbar-logo">
        <NavLink {...navigation} >
          <Image src={this.props.logo} className="img-responsive"
            alt={ formatMessage(messages.headerLogo) + this.props.facilityName }
          />
        </NavLink>
            </div>);
  }

  handleClick = (e) => {
    e.preventDefault();
    let route = '/';
    if (this.isKiosk()) {
      route = '/kioskQuestionnaires';
    }
    if (!this.props.isDedicatedWorkflow) {
      history.push(route);
    }
  }

  isKiosk() {
    let isKiosk = false;
    if (window.location.pathname.toLowerCase().indexOf('kiosk') > -1) {
      isKiosk = true;
    } else if (this.props.loginType &&
      [
        'patientkioskmanagement',
        'patientkioskuser',
        'patientlinkuser',
      ].indexOf(this.props.loginType.toLowerCase()) > -1) {
      isKiosk = true;
    }
    return isKiosk;
  }

  renderLogo() {
    let navigation;
    if (!this.props.isDedicatedWorkflow && !this.isKiosk()) {
      navigation = {
        to: '/',
      };
    }
    return this.buildLogo(navigation);
  }

  renderFacilityName() {
    let href = '#';
    if (this.isKiosk()) {
      href = '/kioskQuestionnaires';
    }
    return (
      <div className="navbar-brand">
        <a className="brand-text" href={href} onClick={this.handleClick}>{this.props.facilityName}</a>
      </div>
    );
  }

  renderUnauthenticatedNavItems() {
    return (
      <span></span>
    );
  }

  renderHealthSummaryLink(isHealthSummaryEnabled, ccdaExternalSystems, className, handleToggleHamburgerMenu) {
    if (!isHealthSummaryEnabled) {
      return null;
    }
    if (ccdaExternalSystems && ccdaExternalSystems.length) {
      return (
        <LinkContainer className={className} to="/health-summary">
          <NavItem onClick={ handleToggleHamburgerMenu }>
            <FormattedMessage {...links.healthSummary} />
          </NavItem>
        </LinkContainer>
      );
    }

    return (
      <NavItem onClick={ this.displayMuCcdaNotConfiguredMessage(handleToggleHamburgerMenu) } className={className}>
        <FormattedMessage {...links.healthSummary} />
      </NavItem>
    );
  }

  renderAuthDesktopViewResourcesNavDropdown() {
    const {
      capabilities,
      intl: {
        formatMessage,
      } } = this.props;

    let menuItems = mapResourcesCapabilities(capabilities);
    menuItems = menuItems.filter((item) => item.isDesktopMenuItem);
    if (!menuItems || !menuItems.length) {
      return null;
    }
    menuItems.sort((a, b) => a.DesktopMenuSortOrder - b.DesktopMenuSortOrder);
    return [
      <NavDropdown className="visible-md-inline visible-lg-inline" id="resourcesmenu"
        title={formatMessage(messages.navigation.resources)}
        key="resourcesNavDropdown"
      >
          {
            menuItems.map((item, key) =>
              (<LinkContainer
                to={item.route}
                key={'menuitem-' + key}
              >
                  <NavItem role="menuitem">
                    <FormattedMessage {...links[item.id]} />
                  </NavItem>
               </LinkContainer>))
          }
      </NavDropdown>,
      <NavSeparator key="desktopmenuSplitter1" />,
      <LanguageSelectionDropdown
        selectId="languageDropdown-desktop"
        key="languageDropdownMenuItem"
        inMenu
        visibilityClass="visible-md-inline visible-lg-inline"
      />,
      <NavSeparator key="desktopmenuSplitter2" />,
    ];
  }

  renderAuthHamburgerViewResources() {
    const {
      capabilities,
    } = this.props;

    let menuItems = mapResourcesCapabilities(capabilities)
      .filter((item) => item.isHamburgerMenuItem);

    if (!menuItems) {
      return null;
    }
    menuItems = menuItems.filter((item) => item.isHamburgerMenuItem);
    menuItems.sort((a, b) => a.hamburgerMenuSortOrder - b.hamburgerMenuSortOrder);

    return [
      menuItems.map((item, key) => (
        <LinkContainer className="visible-xs-inline visible-sm-inline"
          to={item.route}
          key={'hamburgermenuitem-' + key}
        >
          <NavItem href="#" onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links[item.id]} />
          </NavItem>
        </LinkContainer>
      )),
      <LanguageSelectionDropdown
        selectId="languageDropdown-hamburger"
        key="languageDropdownMenuItem"
        inMenu
        visibilityClass="visible-xs-inline visible-sm-inline"
      />,
    ];
  }

  renderAuthHamburgerKioskItems() {
    return [
      <LanguageSelectionDropdown
        selectId="languageDropdown-hamburger"
        key="languageDropdownMenuItem"
        inMenu
        visibilityClass="visible-xs-inline visible-sm-inline"
      />,
    ];
  }

  renderKioskNavItems() {
    const {
      intl: {
        formatMessage,
      },
      user,
      patient,
    } = this.props;
    let userName = {};
    if (user && user.firstName && user.lastName) {
      userName = {
        0: user.firstName,
        1: user.lastName,
      };
    } else {
      userName = {
        0: patient.firstName,
        1: patient.lastName,
      };
    }
    const fullName = formatMessage(messages.displayNameFormat, userName);
    return (
      <Nav pullRight>
        {this.renderAuthHamburgerKioskItems()}
        <LinkContainer className="visible-xs-inline visible-sm-inline" to="/logout" onClick={this.logout}>
          <NavItem onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links.logout} />
          </NavItem>
        </LinkContainer>
        <LanguageSelectionDropdown
          selectId="languageDropdown-desktop"
          key="languageDropdownMenuItem"
          inMenu
          visibilityClass="visible-md-inline visible-lg-inline"
        />
        <NavSeparator key="desktopmenuSplitter2" />
        <NavDropdown className="visible-md-inline visible-lg-inline" id="userAccountMenu" title={fullName}>
          <LinkContainer to="/logout" onClick={this.logout}>
            <NavItem>
              <FormattedMessage {...links.logout} />
            </NavItem>
          </LinkContainer>
        </NavDropdown>
      </Nav>
    );
  }

  renderAuthenticatedNavItems() {
    if (this.isKiosk()) {
      return this.renderKioskNavItems();
    }
    if (this.props.isDedicatedWorkflow) {
      return null;
    }
    const {
      intl: {
        formatMessage,
      },
      externalSystems,
      capabilities,
      stateCounter,
      patient,
      dispatch,
      user,
    } = this.props;

    const tabs = mapCapabilities(
      capabilities,
      stateCounter,
      patient.patientId,
      dispatch);
    const fullName = user.firstName + ' ' + user.lastName;
    tabs.sort((a, b) => a.hamburgerMenuSortOrder - b.hamburgerMenuSortOrder);

    const contactUsTab = tabs.find((a) => a.id === 'contactus');
    const contactUsLink = (contactUsTab) ?
      (<LinkContainer className="visible-md-inline visible-lg-inline" to="/contact-us">
          <NavItem href="#" aria-label={ formatMessage(messages.screenReader.contactUsLink) }>
            <FormattedMessage {...links.contactus} />
          </NavItem>
       </LinkContainer>) : null;
    const contactUsSplitter = (contactUsTab) ?
        <NavSeparator /> : null;
    const secureMessageTab = tabs.find((a) => a.id === 'securemessages');
    const secureMessageIcon = (secureMessageTab) ?
      (
        <SecureMessageNavLink tab={secureMessageTab}/>) : null;
    const secureMessageSplitter = (secureMessageTab) ?
      <NavSeparator /> : null;

    const dashBoardTab = tabs.find((x) => x.id === 'dashboard');
    const healthSummary = dashBoardTab ? dashBoardTab.hasHealthSummary : false;
    let ccdaExternalSystems = null;
    if (externalSystems && externalSystems.length) {
      ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
    }

    const healthSummaryLink = this.renderHealthSummaryLink(healthSummary, ccdaExternalSystems);
    const healthSummaryHamburgerLink = this.renderHealthSummaryLink(healthSummary, ccdaExternalSystems,
      'visible-xs-inline visible-sm-inline', this.toggleHamburgerMenu);
    return (
      <Nav pullRight>
        {
          tabs.map((tab, index) => (
            tab.route ?
            <LinkContainer className="visible-xs-inline visible-sm-inline" eventKey={index} key={index} to={tab.route}
              data-qa-tab={'hb_' + tab.id}
            >
              <NavItem onClick={ this.toggleHamburgerMenu }>
                <FormattedMessage {...links[tab.id]} />
                <Badge badgeProperties={tab.badgeProperties}
                  className="visible-xs-inline visible-sm-inline"
                />
              </NavItem>
            </LinkContainer> :
              null
          ))
        }
        <NavItemSeparator className="divider visible-xs-block visible-sm-block" />

        {this.renderAuthHamburgerViewResources()}

        <NavItemSeparator className="divider visible-xs-block visible-sm-block" />

        <LinkContainer className="visible-xs-inline visible-sm-inline" to="/account-settings">
          <NavItem onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links.accountSettings} />
          </NavItem>
        </LinkContainer>
        {healthSummaryHamburgerLink}
        <LinkContainer className="visible-xs-inline visible-sm-inline" to="/personal-data">
          <NavItem onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links.dataProtection} />
          </NavItem>
        </LinkContainer>

        <NavItemSeparator className="divider visible-xs-block visible-sm-block" />

        <LinkContainer className="visible-xs-inline visible-sm-inline" to="/logout" onClick={this.logout}>
          <NavItem onClick={ this.toggleHamburgerMenu }>
            <FormattedMessage {...links.logout} />
          </NavItem>
        </LinkContainer>

        {this.renderAuthDesktopViewResourcesNavDropdown()}

        { contactUsLink }
        { contactUsSplitter }

        { secureMessageIcon ?
          <LinkContainer
            className="visible-md-inline visible-lg-inline no-background-color"
            to="/secure-messages"
            data-qa-item="secureMsgIcon"
          >
            { secureMessageIcon }
          </LinkContainer> : null}
        { secureMessageSplitter }
        <NavDropdown className="visible-md-inline visible-lg-inline" id="userAccountMenu" title={fullName}>
          <LinkContainer to="/account-settings">
            <NavItem role="menuitem">
              <FormattedMessage {...links.accountSettings} />
            </NavItem>
          </LinkContainer>
          {healthSummaryLink}
          <LinkContainer to="/personal-data">
            <NavItem>
              <FormattedMessage {...links.dataProtection} />
            </NavItem>
          </LinkContainer>

          <NavItemSeparator className="divider" />

          <LinkContainer to="/logout" onClick={this.logout}>
            <NavItem>
              <FormattedMessage {...links.logout} />
            </NavItem>
          </LinkContainer>
        </NavDropdown>
      </Nav>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { isAuthenticated, isEulaAccepted } = this.props;
    if (this.props.capabilities && this.props.capabilities.length > 0) {
      return (
        <div>
          <Navbar staticTop fluid id="header">
            <Navbar.Header>
              <Navbar.Toggle onClick={ this.toggleHamburgerMenu }>
                <span className="sr-only">{ formatMessage(messages.navigation.toggleMenu) }</span>
                <span className="hamburger-label">{ formatMessage(messages.navigation.hamburgerBar) }</span>
                <div className="hamburger-bars clearfix">
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </div>
              </Navbar.Toggle>
              { isAuthenticated ?
                this.renderFacilityName()
                :
                this.renderLogo() }
            </Navbar.Header>
            <Navbar.Collapse in={ this.state.hamburgerMenuOpen }>
              {
                isAuthenticated && (isEulaAccepted || this.isKiosk()) ?
                  this.renderAuthenticatedNavItems() :
                  this.renderUnauthenticatedNavItems()
              }
            </Navbar.Collapse>
          </Navbar>
        </div>
      );
    }

    return (
      <div>
          <Navbar staticTop fluid id="header">
            <Navbar.Header>
            { isAuthenticated ?
              this.renderFacilityName()
              :
              this.renderLogo() }
            </Navbar.Header>
          </Navbar>
      </div>
    );
  }
}

Menu.propTypes = {
  facilityName: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isEulaAccepted: PropTypes.bool,
  capabilities: PropTypes.array,
  user: PropTypes.object,
  logo: PropTypes.string,
  intl: PropTypes.object,
  isDedicatedWorkflow: PropTypes.bool,
  dispatch: PropTypes.func,
  patient: PropTypes.object,
  loginType: PropTypes.string,
  stateCounter: PropTypes.shape({
    education: PropTypes.number,
    testresults: PropTypes.number,
    medicalnotes: PropTypes.number,
    questionnaires: PropTypes.number,
    treatmentsummary: PropTypes.number,
    securemessages: PropTypes.number,
  }),
  externalSystems: PropTypes.array,
};

const mapStateToProps = (state) => ({
  facilityName: state.facility.facilityName,
  capabilities: state.capability.capabilities,
  isAuthenticated: state.profile.auth.isAuthenticated,
  isEulaAccepted: state.profile.user.isEulaAccepted,
  user: state.profile.user,
  logo: state.facility.logo,
  isDedicatedWorkflow: state.workflow.isDedicatedWorkflow,
  patient: state.profile.patient,
  loginType: state.profile.auth.loginType,
  stateCounter: {
    education: state.education.unreadArticlesCount,
    testresults: state.testResults.notReviewedTestResultsCount,
    medicalnotes: state.medicalNotes.isNotReviewedByPatientCount,
    questionnaires: state.questionnaires.newQuestionnaireCount,
    treatmentsummary: state.treatmentSummary.unseenTreatmentSummaryItems,
    securemessages: state.secureMessage.unreadCount,
  },
  externalSystems: state.externalSystems.externalSystems,
});

export default connect(mapStateToProps)(injectIntl(Menu));